export const CUSTODY_PATTERNS = [
  {
    id: '2-2-3',
    name: '2-2-3 Rotation',
    description: 'Mon-Tue with Parent A, Wed-Thu with Parent B, Fri-Sun alternates. Equal time over 2 weeks.',
    cycleLength: 14,
    cycleDays: [
      1, 1, 2, 2, 1, 1, 1,
      1, 1, 2, 2, 2, 2, 2
    ],
    popular: true
  },
  {
    id: 'alternating-weeks',
    name: 'Alternating Weeks',
    description: 'One full week with each parent, alternating every Sunday.',
    cycleLength: 14,
    cycleDays: [
      1, 1, 1, 1, 1, 1, 1,
      2, 2, 2, 2, 2, 2, 2
    ],
    popular: true
  },
  {
    id: '3-4-4-3',
    name: '3-4-4-3 Rotation',
    description: '3 days with Parent A, 4 days with Parent B, then swap. Equal time over 2 weeks.',
    cycleLength: 14,
    cycleDays: [
      1, 1, 1, 2, 2, 2, 2,
      2, 2, 2, 2, 1, 1, 1
    ],
    popular: true
  },
  {
    id: '5-2',
    name: '5-2 Schedule',
    description: 'Weekdays with one parent, weekends with the other. Consistent weekly routine.',
    cycleLength: 7,
    cycleDays: [
      2, 1, 1, 1, 1, 1, 2
    ],
    popular: false
  },
  {
    id: 'full-custody',
    name: '100% One Household',
    description: 'All time with one household. For families using the platform without shared custody.',
    cycleLength: 7,
    cycleDays: [1, 1, 1, 1, 1, 1, 1],
    popular: false
  },
  {
    id: 'every-other-weekend',
    name: 'Every Other Weekend',
    description: 'One parent has primary custody, other parent gets every other weekend (Fri-Sun).',
    cycleLength: 14,
    cycleDays: [
      1, 1, 1, 1, 1, 2, 2,
      1, 1, 1, 1, 1, 1, 1
    ],
    popular: false
  },
  {
    id: 'custom',
    name: 'Custom schedule',
    description: 'Build your own two-week rotation, day by day.',
    cycleLength: 14,
    cycleDays: [
      1, 1, 1, 1, 1, 1, 1,
      2, 2, 2, 2, 2, 2, 2
    ],
    popular: false
  }
];

export const getPatternById = (id) => {
  return CUSTODY_PATTERNS.find(p => p.id === id);
};
